import { get, head, sortBy } from 'lodash-es';

import { useScrollObserverStore } from '../stores/useScrollObserverStore';

import type { ScrollObserverRootId } from '../provider/ScrollObserverProvider';

type UseScrollObserverEntryProps = {
  rootId: ScrollObserverRootId;
};

const getRatio = (targetHeight: number, minHeight: number) => {
  return Math.min(targetHeight / minHeight, 1);
};

export default function useRatioIntersectingEntry({ rootId }: UseScrollObserverEntryProps) {
  const entryId = useScrollObserverStore(({ entries }) => {
    const intersectionEntries = entries.filter(
      entry => entry.rootId === rootId && entry.isIntersecting,
    );

    if (intersectionEntries.length <= 0) return;

    const minEntryHeight = get(
      head(sortBy(intersectionEntries, a => a.boundingClientRect.height)),
      'boundingClientRect.height',
    );
    if (!minEntryHeight) return;

    let selectedEntry = { entryId: '', ratio: 0 };

    for (const entry of intersectionEntries) {
      const ratio = getRatio(entry.intersectionRect.height, minEntryHeight);
      if (ratio > selectedEntry.ratio) {
        selectedEntry = { entryId: entry.entryId, ratio };
      }
    }

    if (selectedEntry.ratio > 0) return selectedEntry.entryId;
  });

  return entryId;
}
